'use client';

import { motion } from 'motion/react';

export default function Flow() {
  const steps = [
    {
      num: "1",
      title: "Create Ecosystem",
      desc: "Organization initializes the master digital entity.",
      active: true
    },
    {
      num: "2",
      title: "Define Regions",
      desc: "Establish Federations to govern localized play.",
      active: false
    },
    {
      num: "3",
      title: "Launch Comps",
      desc: "Competitions are created within regional limits.",
      active: false
    },
    {
      num: "4",
      title: "Teams Onboard",
      desc: "Existing or new teams register for play.",
      active: false
    },
    {
      num: "5",
      title: "Live Play",
      desc: "Players compete and real-time stats are captured.",
      active: false
    }
  ];

  return (
    <section className="bg-[#0f0f0f] py-24 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16 text-center text-3xl font-black tracking-tight text-white md:text-4xl"
        >
          Operational Flow
        </motion.h2>

        <div className="relative flex flex-col justify-between gap-8 md:flex-row">
          {/* Connecting Line for Desktop */}
          <div className="absolute top-6 left-0 hidden h-px w-full bg-zinc-800 md:block" />

          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative z-10 flex flex-1 flex-col items-center text-center"
            >
              <div
                className={`mb-6 flex h-12 w-12 items-center justify-center rounded-full text-sm font-bold ${
                  step.active ? 'bg-[#b4ff00] text-black' : 'bg-zinc-800 text-white'
                }`}
              >
                {step.num}
              </div>
              <h3 className="mb-2 text-sm font-bold text-white">{step.title}</h3>
              <p className="max-w-[200px] text-xs text-zinc-400 leading-relaxed">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
